/* eslint-disable react/no-danger */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-use-before-define */
/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from "react";
import ReactAudioPlayer from "react-audio-player";
import { Box } from "@mui/system";
import { useTheme } from "@mui/material";
import { isEqual } from "lodash";
import { FormattedMessage } from "react-intl";
import { isEmpty } from "../../../../utils/helpers/helpers";
import RollBackIcon from "../../../../../public/assets/icons/RollBackIcon";
import XCircle from "../../../../../public/assets/icons/XCircle";
// If
const optionsBoxStyles = {
  display: "flex",
  alignItems: "flex-start",
  flexDirection: "column",
  marginLeft: 2,
  p: 1
};

function SortPositionCard({ answerTotalQuestion, options, addDataToStateSortPosition, questionId, solutionData }: any) {
  const [arraySelectionData, setArraySelectionData] = useState<any>();
  const [itemsData, setItemsData] = useState<any>();
  const theme: any = useTheme();
  const actionClickCharacterSortPosition = (value: any) => {
    const tempArraySelectionData = arraySelectionData;
    if (Array.isArray(arraySelectionData[0])) {
      arraySelectionData.find((ele: any, i: string | number) => {
        const indexEmpty = ele.findIndex((e: any) => !e);
        if (indexEmpty > -1) {
          tempArraySelectionData[i][indexEmpty] = value;
          return true;
        }
        return false;
      });
    } else if (arraySelectionData.some((ele: any) => ele?.length > 1)) {
      const indexNull = arraySelectionData.findIndex((el: any) => !el);
      if (indexNull > -1) {
        tempArraySelectionData[indexNull] = value;
      }
    } else {
      const indexNull = arraySelectionData.findIndex((el: any) => !el);
      if (indexNull > -1) {
        tempArraySelectionData[indexNull] = value;
      }
    }
    addDataToStateSortPosition(tempArraySelectionData, questionId);
  };
  const checkShowCorrectAnswer = solutionData && !solutionData?.correct && !solutionData?.skipped;

  useEffect(() => {
    if (isEmpty(solutionData)) {
      let tempArraySelectionData = options.map(() => "");
      let tempItemData: any[];
      if (answerTotalQuestion) {
        tempArraySelectionData = answerTotalQuestion.arrayIndex;
      }
      setArraySelectionData(tempArraySelectionData);
      tempItemData = options.map((ele: any, idx: number) => idx + 1);
      tempArraySelectionData?.forEach((val: any) => {
        if (val) {
          tempItemData = tempItemData.filter((ele: any) => ele !== val);
        }
      });
      setItemsData(tempItemData);
    } else {
      const arrayChooseOptions: any = [];
      if (!solutionData.skipped) {
        solutionData?.answered_options.forEach((opsCorrect: any) => {
          options.forEach((ops: any, idx: number) => {
            if (isEqual(ops?.id, opsCorrect)) {
              arrayChooseOptions.push(idx + 1);
            }
          });
        });
      } else {
        solutionData?.correct_options.forEach((opsCorrect: any) => {
          options.forEach((ops: any, idx: number) => {
            if (isEqual(ops?.id, opsCorrect)) {
              arrayChooseOptions.push(idx + 1);
            }
          });
        });
      }
      setArraySelectionData(arrayChooseOptions);
    }
    // eslint-disable-next-line
  }, [solutionData, answerTotalQuestion]);

  const previewChoose = answerTotalQuestion?.selections?.map(
    (e) => options?.find((ele) => ele.id === e)?.items[0]?.content
  );
  const checkContentImage = options?.some((e) => e?.items[0]?.content?.includes("<img"));
  return (
    <div style={{ width: "100%" }}>
      <div className="grid grid-cols-2 justify-items-center">
        {options?.map((ele: { items: any[] }, idx: number) => (
          <Box sx={optionsBoxStyles} key={idx}>
            {ele && <ShowOptionsSortPosition ele={ele?.items[0]} idx={idx + 1} />}
          </Box>
        ))}
      </div>
      <Box className="center-row" flexWrap="wrap">
        {arraySelectionData?.map((ele: any, index: React.Key | null | undefined) => (
          <Box
            key={index}
            style={{
              border: !solutionData ? `1px solid ${theme.answerOptions.gray}` : "none",
              borderRadius: 16,
              textTransform: "uppercase",
              background: solutionData
                ? solutionData?.correct
                  ? theme.answerOptions.correct
                  : solutionData?.skipped
                  ? theme.answerOptions?.skipped
                  : theme.answerOptions?.inCorrect
                : "none",
              color: solutionData ? "white" : theme.answerOptions.black
            }}
            mt={1}
            className="center-row px-1"
            marginRight="20px"
          >
            <span className="borderSelection center-row">{ele}</span>
          </Box>
        ))}
        {isEmpty(solutionData) && (
          <Box mt={1} className="flex flex-col items-center">
            <button
              type="button"
              onClick={() => {
                addDataToStateSortPosition(
                  options.map(() => ""),
                  questionId
                );
              }}
            >
              <XCircle />
            </button>
            <button
              type="button"
              onClick={() => {
                addDataToStateSortPosition(
                  arraySelectionData?.map((element) =>
                    arraySelectionData?.findLast((e) => e !== "") === element ? "" : element
                  ),
                  questionId
                );
              }}
            >
              <RollBackIcon />
            </button>
          </Box>
        )}
      </Box>
      <Box className="flex mt-[32px] center-row flex-wrap">
        {checkShowCorrectAnswer &&
          solutionData?.correct_options
            ?.map((ele) => options?.findIndex((e) => e.id === ele) + 1)
            ?.map((content) => (
              <Box
                key={content.id}
                style={{
                  borderRadius: 16,
                  textTransform: "uppercase",
                  background: theme.answerOptions.correct,
                  color: "white"
                }}
                mt={1}
                className="center-row px-1"
                marginRight="20px"
              >
                <span className="borderSelection center-row">{content}</span>
              </Box>
            ))}
      </Box>
      <Box display="flex" mt={5} justifyContent="center" className="sm:w-screen md:w-full flex-wrap ">
        {isEmpty(solutionData) &&
          itemsData?.map((value: any, index: number) => (
            <Box
              key={index}
              mt={2}
              className="flex justify-center items-center selection-quiz bg-green-gradient text-white cursor-pointer px-2"
              onClick={() => {
                if (isEmpty(solutionData)) {
                  actionClickCharacterSortPosition(value);
                }
              }}
            >
              {value}
            </Box>
          ))}
      </Box>
      {previewChoose?.length > 0 && !checkContentImage && (
        <div className="px-6 text-gray1 my-2 overflow-x-hidden">
          <span>
            {previewChoose
              ?.filter((item) => item !== undefined)
              .map((e, idx) => (
                <div key={idx} className="sm:mr-[10px] md:mr-0" dangerouslySetInnerHTML={{ __html: e }} />
              ))}
          </span>
        </div>
      )}
      <div className="w-full overflow-x-hidden">
        {solutionData && !checkContentImage && (
          <span className="text-gray1 text-[13px] overflow-x-hidden">
            <FormattedMessage id="quiz.answer" />
            {solutionData?.correct_options.map((e, idx) => (
              <div
                key={idx}
                className="sm:mr-[10px] md:mr-0"
                dangerouslySetInnerHTML={{ __html: options?.find((ele) => ele.id === e)?.items[0]?.content }}
              />
            ))}
          </span>
        )}
      </div>
    </div>
  );
}

export default SortPositionCard;

function ShowOptionsSortPosition({ ele, idx }: any) {
  if (isEmpty(ele)) return null;
  switch (ele?.content_type) {
    case "image":
      return (
        <Box display="flex" justifyContent="center">
          {idx}.
          <img
            src={ele?.content}
            alt=""
            style={{
              maxWidth: 496,
              maxHeight: 200,
              width: "100%",
              height: "100%",
              objectFit: "contain"
            }}
          />
        </Box>
      );
    case "audio":
      return (
        <Box my={1} display="flex" justifyContent="center">
          {idx}.
          <ReactAudioPlayer src={ele?.content} controls />
        </Box>
      );
    default:
      return (
        <Box display="flex" alignItems="baseline">
          {idx}.
          {ele?.content && (
            // eslint-disable-next-line
            <div dangerouslySetInnerHTML={{ __html: ele?.content }} />
          )}
        </Box>
      );
  }
}
